"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MESSAGE_MEDIA_META_DEFAULTS = exports.MESSAGE_MEDIA_TYPES = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _MESSAGE_MEDIA_META_D;

var MESSAGE_MEDIA_TYPES = {
  PDF: 'PDF',
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  LINK: 'LINK'
};
exports.MESSAGE_MEDIA_TYPES = MESSAGE_MEDIA_TYPES;
var MESSAGE_MEDIA_META_DEFAULTS = (_MESSAGE_MEDIA_META_D = {}, (0, _defineProperty2["default"])(_MESSAGE_MEDIA_META_D, MESSAGE_MEDIA_TYPES.PDF, {
  '@type': 'PDFMetadata'
}), (0, _defineProperty2["default"])(_MESSAGE_MEDIA_META_D, MESSAGE_MEDIA_TYPES.VIDEO, {
  '@type': 'VideoMetadata'
}), (0, _defineProperty2["default"])(_MESSAGE_MEDIA_META_D, MESSAGE_MEDIA_TYPES.IMAGE, {
  '@type': 'ImageMetadata'
}), (0, _defineProperty2["default"])(_MESSAGE_MEDIA_META_D, MESSAGE_MEDIA_TYPES.LINK, {
  '@type': 'LinkMetadata'
}), _MESSAGE_MEDIA_META_D);
exports.MESSAGE_MEDIA_META_DEFAULTS = MESSAGE_MEDIA_META_DEFAULTS;
var _default = {
  MESSAGE_MEDIA_TYPES: MESSAGE_MEDIA_TYPES
};
exports["default"] = _default;